import GetShopPaymentRequestModelBase from '../_generated/modelBases/get-shop-payment-request-model-base';

export default class GetShopPaymentRequestModel extends GetShopPaymentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
